import * as React from "react";
import * as ReactDOM from "react-dom";
import "tailwindcss/tailwind.css";

import App from "./containers/App";
ReactDOM.render(<App />, document.getElementById("vimeography_admin_app"));
